import yup from '@y2/yup';
import texts from './contact-form.texts.json';

const ONLY_LETTERS_AND_SPACES_REGEX = /^[א-תa-zA-Z ]*$/;

export const validationSchema = yup
  .object({
    fullName: yup
      .string()
      .matches(ONLY_LETTERS_AND_SPACES_REGEX, texts.errors.invalidName)
      .required(texts.errors.fullName),
    email: yup
      .string()
      .email(texts.errors.invalidEmail)
      .required(texts.errors.email),
    projectName: yup.string().required(texts.errors.projectName),
    phone: yup.string().phone().required(),
    companyName: yup.string().required(texts.errors.companyName),
    city: yup.string().required(texts.errors.city),
    description: yup.string().optional(),
  })
  .required();
